/* eslint-disable */
import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import Graph from "../../components/Graph";
import GraphLoader from "../../components/GraphLoader";
import NoDataAvailable from "../../components/NoDataAvailable";
import { GRAPH_VIEW } from "actions/passwordRegex";
const Turck = memo(
  ({
    deviceType,
    graphLoader,
    turckGraphData,
    washData,
    sensors,
    showAnnotation,
    alerts,
    manualAnnotation,
    getAlerts,
    configId,
    dropdownTime,
    isResponsiveMode,
    currentActiveView
  }) => {
    const { t } = useTranslation();
    return (
      <>
        {deviceType === "TURCK_TANKS" && currentActiveView === GRAPH_VIEW ? (
          (graphLoader || turckGraphData === null) ? (
            <GraphLoader />
          ) : turckGraphData === "" ? (
            <center>
              <NoDataAvailable title={t("no_data")} />
            </center>
          ) : (
            <Row>
              <Col lg={12}>
                <Graph
                  data={turckGraphData}
                  washData={washData}
                  sensors={sensors.TURCK_TANKS}
                  graphId="turck"
                  showAnnotation={showAnnotation}
                  alerts={alerts}
                  manualAnnotation={manualAnnotation}
                  getAlerts={getAlerts}
                  configId={configId}
                  dropdownTime={dropdownTime}
                  isResponsiveMode={isResponsiveMode}
                  deviceType={deviceType}
                />
              </Col>
            </Row>
          )
        ) : null}
      </>
    );
  }
);

export default Turck;

